import PropTypes from "prop-types";
import { memo } from "react";
const propTypes = {
  /**
   * Children content of the button.
   */
  children: PropTypes.node,

  /**
   * HTML disabled attribute
   */
  disabled: PropTypes.bool,

  /**
   * Function triggered on button's click event.
   */
  onClick: PropTypes.func.isRequired,
};

/**
 * This component displays a simple button.
 */
function Button({ children, disabled, onClick, ...props }) {
  return (
    <div
      className="tm-button"
      disabled={disabled}
      onClick={(e) => {
        if (disabled) {
          return;
        }
        onClick(e);
      }}
      onKeyPress={(e) => e.which === 13 && onClick(e)}
      role="button"
      tabIndex={0}
      {...props}
    >
      {children}
    </div>
  );
}

Button.propTypes = propTypes;

export default memo(Button);
